import Pagination from '@/components/pagination';
import { formatKoreanDate } from '@/lib/date';
import { cn, slugify } from '@/lib/utils';
import { ArticleListProps } from '@/services/types/article.type';
import BellSvg from '@/svg/bell.svg';
import Link from 'next/link';

export default function NoticeList({
  items,
  page,
  totalPages,
  onPageChange,
}: ArticleListProps) {
  return (
    <div className="mx-auto w-full">
      <div className="divide-stroke-white border-stroke-white divide-y border-t border-b">
        {items.map((item, idx) => (
          <Link
            key={item.title + item.viewDatetime + idx}
            href={`/support/contact/${slugify(item.title, item.id)}`}
            className={cn(
              'desktop:py-8 desktop:px-7 flex items-center justify-between px-2 py-6 transition-colors hover:bg-gray-50',
              item.isTop ? 'bg-bg-grayblue' : '',
            )}
          >
            <div className="desktop:gap-2 flex min-w-0 items-center gap-1">
              {!!item.isTop && (
                <BellSvg className="desktop:size-6 size-4.5 shrink-0" />
              )}
              <span className="typo-18 desktop:typo-24 text-level-3 truncate font-bold">
                {item.title}
              </span>
              {item.iconText && (
                <span
                  className="typo-10 shrink-0 rounded-full px-1.5 py-1 font-bold"
                  style={{
                    backgroundColor:
                      item.iconBcolor || 'var(--color-main-orange)',
                    color: item.iconFcolor || 'white',
                  }}
                >
                  {item.iconText}
                </span>
              )}
            </div>
            <span className="typo-14 text-level-6 desktop:typo-20 ml-2 shrink-0 font-semibold">
              {formatKoreanDate(item.viewDatetime)}
            </span>
          </Link>
        ))}
      </div>
      {/* 페이지네이션 */}
      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
}
